import { use, Suspense, useState, useEffect } from "react";
import styles from "./StockMessage.module.scss";
import { useVariant } from "@~/contexts/VariantContext/VariantContext";
import { useProductCardEvent } from "@~/contexts/ProductCardEventContext/ProductCardEventContext";
import { productCardEvents } from "@~/contexts/ProductCardEventContext/productCardEvents";
import { CardComponentProps, Product } from "@~/types/types.ts";

type StockMessageContentProps = {
  product: Product;
};
function StockMessageContent({ product }: StockMessageContentProps) {
  const dispatch = useProductCardEvent();
  const { onlineStock } = useVariant();
  onlineStock.catch(() => {
    dispatch(productCardEvents.onlineStockDataError);
  });
  let stockMessage;
  if (product.isRetired || product.isUnlisted) {
    stockMessage =
      "We no longer stock this item, but we may have similar products available";
  } else {
    const stockData = use(onlineStock);
    stockMessage = stockData?.stockMessage;
  }

  if (!stockMessage) {
    return null;
  }

  return (
    <p data-component="pcl-StockMessage" className={styles.message}>
      {stockMessage}
    </p>
  );
}

function StockMessageLoading() {
  return (
    <p
      data-component="pcl-StockMessage"
      className={styles["message-loading"]}
    />
  );
}

export function StockMessage({ product }: Pick<CardComponentProps, "product">) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(function markStockMessageAsMounted() {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return <StockMessageLoading />;
  }

  return (
    <Suspense fallback={<StockMessageLoading />}>
      <StockMessageContent product={product} />
    </Suspense>
  );
}
